module.exports = __webpack_public_path__ + "static/img/img24.b752c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img24.png
// module id = wxvG
// module chunks = 1